export default "/wstETH-WETH-BPT.917ce827066803ffbf5e78d28ee428ce.png";